import { useEffect, useState } from "react";
import { ImagesGrid } from "polotno/side-panel/images-grid";
import { SectionTab } from "polotno/side-panel";
import BsCloudUpload from "@meronex/icons/bs/BsCloudUpload";
import BsUpload from "@meronex/icons/bs/BsUpload";
import { observer } from "mobx-react-lite";
import { firestore, storage } from "../firebase";
import { useSelector } from "react-redux";

export const UploadPanel = observer(({ store }) => {
  const [images, setImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));
  async function loadImages() {
    // here we should implement your own API requests
    setImages([]);

    // wait to emulate network request
    const snapshot = await firestore
      .collection("uploaded")
      .where("userId", "==", currentUser.uid)
      .get();
    if (snapshot.empty) {
      setImages([]);
    } else {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setImages(list);
    }
  }

  const firestoreChanges = () => {
    const doc = firestore
      .collection("uploaded")
      .where("userId", "==", currentUser.uid);
    doc.onSnapshot(
      (docSnapshot) => {
        if (docSnapshot.empty) {
          setImages([]);
        } else {
          const list = docSnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setImages(list);
        }
      },
      (err) => {
        console.log(`Encountered error: ${err}`);
      }
    );
  };
  useEffect(() => {
    loadImages();
    firestoreChanges();
  }, []);

  const getImageRatio = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = function () {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = function () {
        resolve({ width: 100, height: 150 });
      };
    });
  };

  const uploadImage = async (e) => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const localFile = files[0];
    if (localFile.type.includes("image")) {
      setUploading(true)
      const child = `${currentUser.uid}/uploaded/${
        localFile.name
      }-${new Date().getTime()}`;
      const uploadSnapchot = await storage.ref().child(child).put(localFile);
      const imageLink = await uploadSnapchot.ref.getDownloadURL();
      await firestore.collection("uploaded").add({
        userId: currentUser.uid,
        url: imageLink,
      });
      setUploading(false)
      loadImages();
    }
  };
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <p>Upload: </p>
      {/* you can create yur own custom component here */}
      {/* but we will use built-in grid component */}
      {images.length === 0 ? (
        <p>You Don't Have Any Uploaded Photos</p>
      ) : (
        <ImagesGrid
          images={images}
          getPreview={(image) => image.url}
          onSelect={async (image, pos, element) => {
            const { width, height } = await getImageRatio(image.url);
            store.activePage.addElement({
              type: "image",
              src: image.url,
              width,
              height,
              x: pos?.x || 0,
              y: pos?.y || 0,
            });
          }}
          rowsNumber={2}
          isLoading={!images.length || uploading}
          loadMore={false}
        />
      )}
      <div style={{ "margin-bottom": "20px" }}>
        <label htmlFor="input-file">
          <span
            type="button"
            className="bp3-button"
            style={{ width: "100%" }}
          >
            <BsUpload icon="upload" />
            <span className="bp3-button-text">Upload Image</span>
          </span>
        </label>
        <input
          type="file"
          id="input-file"
          accept="image/*"
          name="input-file"
          onChange={(e) => uploadImage(e)}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
});

const UploadSection = {
  name: "uploaded",
  Tab: (props) => (
    <SectionTab name="Upload" {...props}>
      <BsCloudUpload icon="upload" />
    </SectionTab>
  ),
  Panel: UploadPanel,
};

export default UploadSection;
